import { skipToken, useQuery } from '@tanstack/react-query';

import { type EntityBreadcrumbName } from '@/layouts/routes/Route.model.ts';

const UNAVAILABLE_KEY = ['breadcrumbs', 'entityName', 'unavailable'] as const;

/**
 * Observes the react-query cache for an entity's display name (OCD-311).
 * Declared with `skipToken`, so it never fetches — it only mirrors whatever
 * the underlying view cached under the same key and stays reactive to cache
 * updates (e.g. details landing after mount). Returns null while the cache
 * holds nothing, so the static breadcrumb label remains the fallback.
 */
export const useEntityBreadcrumbName = (
  entityName: EntityBreadcrumbName | undefined,
  entityId: string | undefined,
): string | null => {
  const { data } = useQuery({
    queryFn: skipToken,
    queryKey: entityName && entityId ? entityName.queryKey(entityId) : UNAVAILABLE_KEY,
    select: entityName && entityId ? name => entityName.select(name) : undefined,
  });

  return data ?? null;
};
